<template lang="pug">
    div
        regular-button(@click="open()" :value="BUTTONS_VALUES.add_promotion")
        modal(name="promotion-form" height="auto" :width="520" :adaptive="true" :scrollable="true" classes="form-modal")
            .p-4.bg-gray-100
                    .text-lg.font-medium.mb-4 {{ editingId ? 'Изменить акцию' : 'Новая акция' }}
                    text-input(label="Название" :maxlength="300" :value="name" @value="name = $event")
                    template(v-if="canPickGroup")
                        select-option.mt-3(
                            :key="openTick"
                            label="Станция"
                            name="promotion-group"
                            :options="stations"
                            :predefined="stationName"
                            @value="onGroup"
                        )
                    text-area.mt-3(label="Приз" :maxlength="400" :value="prize" @value="prize = $event")
                    text-input.mt-3(label="Ссылка на правила" :maxlength="2000" :value="rulesUrl" @value="rulesUrl = $event" placeholder="https://")
                    .mt-4.flex.items-center
                        checkbox(:checked="active" @value="active = $event")
                            .ml-2.text-sm Активен
                    .mt-4
                        .text-xs Активен до
                        .flex.gap-2.mt-1
                            input.h-10.px-2.border.rounded.border-slate-300.bg-white(
                                type="date"
                                v-model="untilDate"
                            )
                            select.h-10.px-2.border.rounded.border-slate-300.bg-white(v-model="untilHour")
                                option(value="") часы
                                option(v-for="hour in hours" :key="hour" :value="hour") {{ hour }}
                            select.h-10.px-2.border.rounded.border-slate-300.bg-white(v-model="untilMinute")
                                option(value="") минуты
                                option(v-for="minute in minutes" :key="minute" :value="minute") {{ minute }}
                        .text-xs.text-gray-500.mt-1 Время московское, от 00:00 до 23:59. Если пусто, статус меняют вручную.
                    .flex.gap-3.mt-6
                        regular-button.w-200(:value="BUTTONS_VALUES.save_promotion" :loading="saving" @click="onSave")
                        regular-button.w-200(:value="BUTTONS_VALUES.cancel" color="gray" @click="close")
</template>

<script>
import moment from 'moment';
import TextInput from '@/components/common/forms/text-input';
import TextArea from '@/components/common/forms/text-area';
import RegularButton from '@/components/common/buttons/regular-button';
import SelectOption from '@/components/common/forms/select-option';
import Checkbox from '@/components/common/checkbox';
import { BUTTONS_VALUES } from '@/configs/names';
import { USER_GROUPS } from '@/configs/user-groups';
import { PromotionsNameSpace, PromotionsActionTypes } from '@/store/promotions/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';
import { _openModal_, _closeModal_ } from '@/mixins/modals';
import { notifyError } from '@/helpers/notifications';

const toMoscowParts = (value) => {
    if (!value) {
        return { date: '', hour: '', minute: '' };
    }
    const date = moment(value).utcOffset(180);
    if (!date.isValid()) {
        return { date: '', hour: '', minute: '' };
    }
    return {
        date: date.format('YYYY-MM-DD'),
        hour: date.format('HH'),
        minute: date.format('mm'),
    };
};

export default {
    name: "PromotionForm",
    mixins: [_openModal_, _closeModal_],
    components: {
        'text-input': TextInput,
        'text-area': TextArea,
        'regular-button': RegularButton,
        'select-option': SelectOption,
        'checkbox': Checkbox,
    },
    data() {
        return {
            openTick: 0,
            editingId: null,
            name: '',
            group: null,
            stationName: '',
            prize: '',
            rulesUrl: '',
            active: true,
            untilDate: '',
            untilHour: '',
            untilMinute: '',
            saving: false,
        }
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        stations() {
            const stations = USER_GROUPS.filter((group) => group.value !== 1)
            if (!this.canPickGroup) {
                return stations
            }
            return [{ name: 'Общая', value: 0 }, ...stations]
        },
        userRole() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
        },
        canPickGroup() {
            return this.userRole === 1 || this.userRole === 2 || this.userRole === 6
        },
        hours() {
            return Array.from({ length: 24 }, (_, hour) => String(hour).padStart(2, '0'))
        },
        minutes() {
            return Array.from({ length: 60 }, (_, minute) => String(minute).padStart(2, '0'))
        },
    },
    methods: {
        open(item) {
            this.openTick += 1
            if (item) {
                const station = this.stations.find((group) => group.value === Number(item.group))
                this.editingId = item._id
                this.name = item.name || ''
                this.group = Number(item.group)
                this.stationName = Number(item.group) === 0 ? 'Общая' : (station ? station.name : '')
                this.prize = item.prize || ''
                this.rulesUrl = item.rules_url || ''
                this.active = Boolean(item.active)
                const until = toMoscowParts(item.active_until)
                this.untilDate = until.date
                this.untilHour = until.hour
                this.untilMinute = until.minute
            } else {
                this.editingId = null
                this.name = ''
                this.group = null
                this.stationName = ''
                this.prize = ''
                this.rulesUrl = ''
                this.active = true
                this.untilDate = ''
                this.untilHour = ''
                this.untilMinute = ''
            }
            this._openModal_({ name: 'promotion-form' })
        },
        close() {
            this._closeModal_({ name: 'promotion-form' })
        },
        onGroup(value) {
            const station = this.stations.find((group) => group.name === value)
            this.group = station ? station.value : null
            this.stationName = station ? station.name : ''
        },
        payload() {
            const body = {
                name: this.name.trim(),
                prize: this.prize.trim(),
                rules_url: this.rulesUrl.trim(),
                active: this.active,
                active_until: this.untilDate
                    ? `${this.untilDate}T${this.untilHour}:${this.untilMinute}`
                    : null,
            }
            if (this.canPickGroup) {
                body.group = this.group
            }
            return body
        },
        validate(body) {
            if (!body.name) {
                return 'Укажите название'
            }
            if (this.canPickGroup && (body.group === null || body.group === undefined || body.group === '')) {
                return 'Укажите станцию'
            }
            if (!body.prize) {
                return 'Укажите приз'
            }
            if (!body.rules_url) {
                return 'Укажите ссылку на правила'
            }
            const hasTime = this.untilHour !== '' || this.untilMinute !== ''
            if (this.untilDate && (this.untilHour === '' || this.untilMinute === '')) {
                return 'Укажите часы и минуты'
            }
            if (!this.untilDate && hasTime) {
                return 'Укажите дату'
            }
            return ''
        },
        async onSave() {
            if (this.saving) {
                return
            }
            const body = this.payload()
            const error = this.validate(body)
            if (error) {
                notifyError({ title: error })
                return
            }
            const action = this.editingId
                ? PromotionsActionTypes.EditPromotion
                : PromotionsActionTypes.AddPromotion
            const request = this.editingId
                ? { id: this.editingId, value: body }
                : { data: body }
            this.saving = true
            try {
                await this.$store.dispatch(`${PromotionsNameSpace}/${action}`, request)
                this.close()
                this.$emit('saved')
            } catch (saveError) {
                return saveError
            } finally {
                this.saving = false
            }
        },
    },
}
</script>
